import { put, select, take } from 'redux-saga/effects';
import { getFormValues } from 'redux-form/immutable';
import { push } from 'redux-little-router';
import { selectDraft } from 'modules/Taps/components/NDFL3Light/selectors';
import { updateDraft } from 'modules/Taps/components/NDFL3Light/redux/actions';
import { UPDATE_DRAFT_SUCCESS } from 'modules/Taps/components/NDFL3Light/redux/actionTypes';
import { STEP_DEDUCTION_FORM } from '../constants';

export function* submitDeductionsSaga({ payload: { getNextStep } }) {
  const draft = yield select(selectDraft);
  const formData = yield select(getFormValues(STEP_DEDUCTION_FORM));
  const charityDeductionKey = ['payload', 'sheetE2', 'charityLiveDeduction', 'donationAmount'];

  yield put(
    updateDraft({
      draft: draft
        .set('currentFormId', 'submit')
        .setIn(['payload', 'sheetE2', 'charityLiveDeductionSelected'], true)
        .setIn(['payload', 'deductionSelector', 'socialDeduction'], true)
        .setIn(charityDeductionKey, formData.getIn(charityDeductionKey)),
    }),
  );
  yield take(UPDATE_DRAFT_SUCCESS);
  yield put(push({ query: { step: getNextStep() } }, { persistQuery: true }));
}
